module.exports = __webpack_public_path__ + "img/ROLLBIT.f8d22dd0.svg";